/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Clear_All_FiltersInputs */

const en_editor_clear_all_filters = /** @type {(inputs: Editor_Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear all filters`)
};

const fr_editor_clear_all_filters = /** @type {(inputs: Editor_Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer tous les filtres`)
};

const de_editor_clear_all_filters = /** @type {(inputs: Editor_Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Filter löschen`)
};

const it_editor_clear_all_filters = /** @type {(inputs: Editor_Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella tutti i filtri`)
};

const ru_editor_clear_all_filters = /** @type {(inputs: Editor_Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить все фильтры`)
};

const es_editor_clear_all_filters = /** @type {(inputs: Editor_Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar todos los filtros`)
};

const zh_cn2_editor_clear_all_filters = /** @type {(inputs: Editor_Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除所有筛选条件`)
};

const ja_editor_clear_all_filters = /** @type {(inputs: Editor_Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのフィルターをクリア`)
};

const hi_editor_clear_all_filters = /** @type {(inputs: Editor_Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी फ़िल्टर साफ़ करें`)
};

const pt_pt2_editor_clear_all_filters = /** @type {(inputs: Editor_Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar todos os filtros`)
};

/**
* | output |
* | --- |
* | "Clear all filters" |
*
* @param {Editor_Clear_All_FiltersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_clear_all_filters = /** @type {((inputs?: Editor_Clear_All_FiltersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Clear_All_FiltersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_clear_all_filters(inputs)
	if (locale === "de") return de_editor_clear_all_filters(inputs)
	if (locale === "it") return it_editor_clear_all_filters(inputs)
	if (locale === "ru") return ru_editor_clear_all_filters(inputs)
	if (locale === "es") return es_editor_clear_all_filters(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_clear_all_filters(inputs)
	if (locale === "ja") return ja_editor_clear_all_filters(inputs)
	if (locale === "hi") return hi_editor_clear_all_filters(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_clear_all_filters(inputs)
	return en_editor_clear_all_filters(inputs)
});